import type { Id } from '../../api/types';

export interface RosterStatus {
  count: number;
  loading: boolean;
  error: string | null;
  // false until the first load() has started; an idle empty store is not an empty class
  requested: boolean;
}

export interface ConductInput {
  classNoteId: Id | undefined;
  subjectId: Id | undefined;
  semester: Id | null;
  roster: RosterStatus;
}

/** Why Thêm is off ('' when live) and whether a retry can fix it - a disabled button with no reason reads as broken. */
export interface ConductGate {
  reason: string;
  retry: boolean;
}

export const CONDUCT_COPY = {
  noClassNote: 'Cần ghi sổ đầu bài của tiết này trước, ghi nhận được lưu kèm sổ đầu bài.',
  noSubject: 'Tiết học chưa gắn môn học nên chưa thêm được ghi nhận.',
  noSemester: 'Chưa có học kỳ hiện hành nên chưa thêm được ghi nhận.',
  rosterLoading: 'Đang tải danh sách học sinh...',
  rosterError: 'Chưa tải được danh sách học sinh của lớp.',
  rosterEmpty: 'Chưa có danh sách điểm danh cho tiết này.',
} as const;

export function conductGate({ classNoteId, subjectId, semester, roster }: ConductInput): ConductGate {
  if (!classNoteId) return { reason: CONDUCT_COPY.noClassNote, retry: false };
  if (!subjectId) return { reason: CONDUCT_COPY.noSubject, retry: false };
  if (semester === null) return { reason: CONDUCT_COPY.noSemester, retry: false };
  if (roster.count > 0) return { reason: '', retry: false };
  if (roster.loading || !roster.requested) return { reason: CONDUCT_COPY.rosterLoading, retry: false };
  if (roster.error) return { reason: CONDUCT_COPY.rosterError, retry: true };
  return { reason: CONDUCT_COPY.rosterEmpty, retry: false };
}
